import * as React from 'react';
import { ChangeEvent } from 'react';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { Value } from '@material-ui/lab/useAutocomplete/useAutocomplete';

interface GenericValue<T, DefaultValue = never> {
  value: T | DefaultValue;
  onChange: (value: T) => void;
}

interface CommonProps<T> {
  options: T[];
  getOptionLabel: (option: T) => string;
  id?: string;
  width?: number | `${number}%`;
  multiple?: boolean;
  onReset: () => void;
}

type SingleProps<T> = CommonProps<T> & GenericValue<T, null>;
type MultipleProps<T> = CommonProps<T> & GenericValue<T[]>;

type Props<T> = SingleProps<T> | MultipleProps<T>;

function AutocompleteInput<T = string>({
  multiple,
  value,
  onChange,
  options,
  getOptionLabel,
  id = 'autocomplete-input',
  width = 300,
  onReset,
}: Props<T>) {
  const handleChange = (event: Object, value: Value<T, boolean, boolean, boolean>): void => {
    onChange(value as T & T[]);
  };

  const handleInputChange = (_event: ChangeEvent<{}>, currentValue: string) => {
    if (currentValue !== '' || multiple) {
      return;
    }
    onReset();
  };

  return (
    <Autocomplete<T, boolean, boolean, boolean>
      freeSolo
      disableClearable={!multiple}
      multiple={multiple}
      id={id}
      options={options}
      value={value}
      onChange={handleChange}
      getOptionLabel={getOptionLabel}
      style={{ width }}
      onInputChange={handleInputChange}
      renderInput={params => (
        <TextField
          {...params}
          placeholder={'Enter a Email'}
          InputProps={{ ...params.InputProps, type: 'search' }}
          fullWidth
        />
      )}
    />
  );
}

export default AutocompleteInput;
